import { RouterProvider } from 'react-router-dom';
import { Toaster } from 'sonner';
import { router } from './router';

export function App() {
  return (
    <>
      <RouterProvider router={router} future={{ v7_startTransition: true }} />
      <Toaster
        theme="dark"
        position="bottom-right"
        toastOptions={{
          style: {
            background: 'var(--panel-2)',
            border: '1px solid var(--line-2)',
            color: 'var(--ink)',
            fontFamily: 'var(--font-sans)',
          },
        }}
      />
    </>
  );
}
